import React from 'react';
import NiceModal from '@ebay/nice-modal-react';

import { ReactSVG } from 'react-svg';

import heartImg from 'images/heart.svg';

import {
  ShareState,
  ShareProjectModal,
} from '@components/overlays/ShareProject';

import { ProductDetailsFragment } from '@sdk/gqlTypes/generatedOperations';
import { SelectedAttributeValueInput } from '@sdk/gqlTypes/generatedTypes';

import { Button } from '@components/atoms/Button';

import { translate } from '@utils/translations';

import {
  generateProductImageWithAttributes,
  generateProductUrlWithAttributes,
} from '@temp/views/Product/utils';

export interface ISaveForLaterButton {
  product: ProductDetailsFragment;
  formAttributes: Record<string, string>;
  productAttributes: SelectedAttributeValueInput[];
  productId: string;
  productName: string;
  variantId: string;
}

export const SaveForLaterButton: React.FC<ISaveForLaterButton> = ({
  product,
  formAttributes,
  productAttributes,
  productId,
  productName,
  variantId,
}) => {
  const showShareProject = (initialState: ShareState) => {
    let productImage;
    let productUrl;
    try {
      // productImage = productViewRef.current?.getScreenshot();
      productImage = generateProductImageWithAttributes(
        product,
        formAttributes
      );
      productUrl = generateProductUrlWithAttributes(product, formAttributes);
    } catch (error) {
      console.error('error: ', error);
    }
    NiceModal.show(ShareProjectModal, {
      initialState,
      selectedProductAttributes: productAttributes,
      productCategory: translate(product.category, 'name'),
      productId: product.slug,
      productImage,
      productName,
      productUrl,
      variantId,
    });
  };

  return (
    <Button
      onClick={() => {
        showShareProject(ShareState.initial);
      }}
      size="sm"
      appearance="outline"
      style={{
        width: '20%',
      }}
    >
      <ReactSVG src={heartImg} />
    </Button>
  );
};
SaveForLaterButton.displayName = 'SaveForLaterButton';
